import $ from 'jquery';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';
import 'picturefill';
import 'foreachfill';
import 'custom-event-polyfill';

// import './Libraries/LFM/BreakpointEvents';
import './Lightbox';
import './Select';
import './Menu';
import './Slider';
import './NavToggle';
// import './CookieConsent';
import './BackToTop';
import './Chat';
import './Header';
// import './LazyLoad';
// import './Gallery';
import './Youtube';
// import './Maps';
import './Accordion';
import './Timeline';
import './Form';
import './Team';
import './Footer';
import './Search';
import './Joboffers';
import './LanguageMenu';
import './ProductFinder';
import './SalesPartner';
import './Datepicker';
import './Teaser';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}
$(window).trigger('resize');  // trigger once on page load
